import { registerPlugin } from '@capacitor/core'
import type { FacebookSharePlugin } from './definitions'

const FacebookShare = registerPlugin<FacebookSharePlugin>('FacebookShare')

export * from './definitions'
export { FacebookShare }
